import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-modal-header',
    templateUrl: './modal-header.component.html',
    styleUrl: './modal-header.component.scss',
    imports: [MatIconModule, NgClass],
    standalone: true
})

export class ModalHeaderComponent {

  @Output() closeEmitter = new EventEmitter<void>();

  @Input({required: true}) title: string = "Título da modal";
  @Input() sizeTitle!: string;
  @Input() icon!: string;
  @Input() svgIcon!: string;
  @Input() closeIcon: string = 'close';
  @Input() hideCloseBtn = false;
  @Input() message!: string; // Mensagem abaixo do título...
  @Input() subtitle!: string;
  @Input() sizeSubtitle!: string;

  handleClose = () => {
    this.closeEmitter.emit();
  }
}
